import React from 'react';
import FormField from './FormField';

const FieldGroup = ({ group, fields, formData, onChange, errors = {} }) => {
  const isRow = group?.layout === 'row';

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      {group?.label && (
        <p style={{
          fontSize: '0.75rem',
          fontWeight: '600',
          color: '#6b7280',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          marginBottom: '0.5rem'
        }}>
          {group.label}
        </p>
      )}
      <div style={isRow ? {
        display: 'flex',
        gap: '1rem',
        alignItems: 'flex-start'
      } : {
        border: '1px solid #e5e7eb',
        borderRadius: '0.5rem',
        padding: '1rem',
        backgroundColor: '#f9fafb'
      }}>
        {fields.map((field) => (
          <div key={field.id} style={isRow ? { flex: 1, minWidth: 0 } : {}}>
            <FormField
              field={field}
              value={formData[field.id]}
              onChange={onChange}
              error={errors[field.id]}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FieldGroup;
